module.exports = __webpack_public_path__ + "static/media/addnews-icon.9bb8794d.svg";